// frontend/src/contexts/UIContext.js
import React, { createContext, useState, useCallback } from 'react';

const UIContext = createContext();

const UIProvider = ({ children }) => {
    const [isFaqModalOpen, setIsFaqModalOpen] = useState(false);
    const [heatmapModalData, setHeatmapModalData] = useState(null);
    const [textInspectionModalData, setTextInspectionModalData] = useState(null);
    const [isPageBlurred, setIsPageBlurred] = useState(false);
    const [isDocViewerOpen, setIsDocViewerOpen] = useState(false);
    const [docContent, setDocContent] = useState(null); // Will hold the fetched docs
    const [isDocLoading, setIsDocLoading] = useState(false);
    const [initialDocPath, setInitialDocPath] = useState(null); // For deep linking
    const [isOnboardingModalOpen, setIsOnboardingModalOpen] = useState(false);

    const openDocViewer = useCallback((path = null) => {
        setInitialDocPath(path);
        setIsDocViewerOpen(true);
    }, []);

    const closeDocViewer = () => {
        setIsDocViewerOpen(false);
        setInitialDocPath(null); // Reset path on close
    };
    
    const value = { 
        isFaqModalOpen, setIsFaqModalOpen,
        heatmapModalData, setHeatmapModalData,
        textInspectionModalData, setTextInspectionModalData,
        isPageBlurred, setIsPageBlurred,
        isDocViewerOpen,
        docContent,
        setDocContent,
        isDocLoading,
        setIsDocLoading,
        initialDocPath,
        openDocViewer,
        closeDocViewer,
        isOnboardingModalOpen,
        setIsOnboardingModalOpen
    };

    return <UIContext.Provider value={value}>{children}</UIContext.Provider>;
};

export { UIContext, UIProvider };